import { graphql } from "gatsby";
import React from "react";

import Shape from "../assets/shapes";
import AppLink from "../components/appLink/AppLink";
import Grid, { Col } from "../components/grid/Grid";
import ItemTile from "../components/itemTile/ItemTile";
import Meta from "../components/meta/Meta";
import Section from "../components/section/Section";
import PageLabel from "../components/pageLabel/PageLabel";
import { kebabCase } from "../utils/kebabCase";

const Blog = ({ data, pageContext }) => {
  const renderPosts = data.allContentfulPost.nodes.map(
    ({ id, image, title, publishedDate, content }) => (
      <ItemTile
        key={id}
        image={image}
        title={title}
        path={`/blog/${kebabCase(title)}`}
        timeToRead={content && content.childMarkdownRemark.timeToRead}
        publishedDate={publishedDate}
        isPost
        height="large"
        marginBottom
      />
    )
  );

  return (
    <article>
      <Section header>
        <Grid>
          <Col span={8} start={1}>
            <PageLabel>Insights</PageLabel>
            <h1 className="noMargin">Think. Share. Learn.</h1>
          </Col>
        </Grid>
      </Section>

      <Section>
        <Grid>
          <Col start={1} span={12}>
            <Grid columns={3}>{renderPosts}</Grid>
          </Col>
        </Grid>
      </Section>

      <Section padding="bottom">
        <Grid padding="top">
          <Col start={1} span={12}>
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              {pageContext.currentPage > 1 ? (
                <AppLink
                  to={`/blog/${
                    pageContext.currentPage === 2 ? "" : pageContext.currentPage - 1
                  }`}
                  type="arrowReverse"
                >
                  Previous
                </AppLink>
              ) : (
                <div />
              )}
              {pageContext.currentPage + 1 <= pageContext.numPages && (
                <AppLink
                  to={`/blog/${pageContext.currentPage + 1}`}
                  type="arrow"
                >
                  Next
                </AppLink>
              )}
            </div>
          </Col>
        </Grid>
      </Section>
    </article>
  );
};

export default Blog;

export const Head = ({ data, pageContext }) => {
  const { seoTitle, description } = data.content.frontmatter;
  return <Meta title={`${seoTitle} - Page ${pageContext.currentPage}`} description={description} />;
}

export const query = graphql`
  query ($skip: Int!, $limit: Int!) {
    content: mdx(frontmatter: { name: { eq: "blog" } }) {
      ...PageDefault
    }
    allContentfulPost(
      sort: { publishedDate: DESC }
      limit: $limit
      skip: $skip
      filter: { private: { ne: true } }
    ) {
      nodes {
        id
        title
        image {
          title
          gatsbyImageData(placeholder: BLURRED)
        }
        publishedDate
        content {
          childMarkdownRemark {
            timeToRead
          }
        }
      }
    }
  }
`;
